import { BenchmarkCategory } from '@/api/generated-catch-backend/model';

export interface RiskConfigData {
  text: string;
  cssClass: string;
  description: string;
  title: string;
  tooltipDescription: string;
}

export const getRiskConfigData = (
  level: BenchmarkCategory,
  currentRisk: number,
  averageRisk: number,
  userGender?: 'male' | 'female' | null
): RiskConfigData => {
  const demographic = userGender === 'male' ? 'men your age' : 'women your age';
  const tooltipDescription = `Your estimated lifetime risk of developing cancer is ${currentRisk}%, compared to the U.S. average of ${averageRisk}% for ${demographic}.`;

  switch (level) {
    case BenchmarkCategory.Below_average:
      return {
        text: 'Below Average Risk',
        cssClass: 'bg-catch-avocado-400',
        description: 'Your risk is lower than the population average',
        title: 'Below Average Risk',
        tooltipDescription,
      };
    case BenchmarkCategory.Average:
      return {
        text: 'Average Risk',
        cssClass: 'bg-catch-yellow',
        description: 'Your risk is similar to the population average',
        title: 'Average Risk',
        tooltipDescription,
      };
    case BenchmarkCategory.Above_average:
      return {
        text: 'Above Average Risk',
        cssClass: 'bg-catch-salmon',
        description: 'Your risk is higher than the population average',
        title: 'Above Average Risk',
        tooltipDescription,
      };
    default:
      return {
        text: 'Average Risk',
        cssClass: 'bg-catch-yellow',
        description: 'Your risk is similar to the population average',
        title: 'Average Risk',
        tooltipDescription,
      };
  }
};